import { cloneDeep } from 'lodash-es'

export default {
    methods: {
        dateFormatDayname(momentDate) {
            const _day = momentDate
            return _day.format('dddd')
        },

        dateFormatDaynumber(momentDate) {
            const _day = momentDate
            return _day.format('DD')
        },

        dateFormatDayPER(momentDate) {
            const _day = momentDate
            return _day.format('YYYY')+'/'+_day.format('MM')+'/'+_day.format('DD')
        },

        dateFormatDayISO(momentDate) {
            const _day = momentDate
            return _day.format('YYYY')+'-'+_day.format('MM')+'-'+_day.format('DD')
        },

        dateFormatDay(momentDate) {
            const _day = momentDate
            return _day.format('YYYY')+'. '+_day.format('MMMM')+' '+_day.format('DD')+'.'
        },

        dateFormatWeekRange(weekStart) {
            const weekEnd = cloneDeep(weekStart).endOf('week')

            if ( weekStart.month() === weekEnd.month() ) {
                return weekStart.format('YYYY')+'. '+weekStart.format('MMMM')+' '+weekStart.format('DD')+'-'+weekEnd.format('DD')+'.'
            } else {
                return weekStart.format('YYYY')+'. '+weekStart.format('MMM')+' '+weekStart.format('DD')+'. - '+weekEnd.format('MMM')+' '+weekEnd.format('DD')+'.'
            }
        },

        dateFormatMonth(monthStart) {
            return monthStart.format('YYYY')+'. '+monthStart.format('MMMM')
        },

        dateFormatMonthName(monthStart) {
            return monthStart.format('MMMM')
        },

        dateFormatMonthShort(monthStart) {
            let short = monthStart.format('MMM')
            return short.replaceAll('.', '')
        },

        dateFormatYear(monthStart) {
            return monthStart.format('YYYY')+'.'
        },
    }
}
